import { css } from '@emotion/css';
import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Leaf } from '../../assets/images/mark-leaf.svg';
import { fontFamily } from '../../lib/font-family';
import { reveal } from './keyframe-animations';

export const LoadingFailed: React.FC<{ error?: string }> = ({ error }) => {
  const { t, i18n } = useTranslation('translation');
  const errorMessage = getText(t, error);
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        color: #938666;
        align-items: center;
        padding: 24px;
        opacity: 0;
        animation: 0.2s ease-in-out ${reveal} both;
        font-family: ${fontFamily(i18n.language || 'en-US')};
        .leaf {
          width: 48px;
          height: 48px;
        }
        .error {
          font-size: 14px;
          text-align: center;
          margin: 24px auto;
        }
      `}
    >
      <div className="leaf">
        <Leaf />
      </div>
      <p className="error">{errorMessage}</p>
    </div>
  );
};

// helper function
function getText(t: TFunction, error?: unknown) {
  switch (error) {
    case 'player-profile-not-found':
      return t('error_player_profile_not_found');
    case 'player-not-in-island':
      return t('error_player_not_in_island');
    case 'unstable-network':
      return t('error_unstable_network');
    case 'communication-error':
      return t('error_generic');
    case 'restart-required':
      return t('error_restart_required');
    default:
      return t('error_unknown');
  }
}
